<template>
    <Card :padding="20" shadow>
        <i-form :model="reclamacao" :rules="rules_validate" label-position="top" ref="reclamacao">
            <Row :gutter="16">
                <i-col :xs="23">
                    <h4>Fale com a Gestão Anonimamente{{reclamacao.hash ? `: ${reclamacao.hash}` : ''}}</h4>
                </i-col>
                <i-col :xs="1">
                    <Tooltip content="Visualizar Reclamação"><Button @click="editarReclamacao()" icon="ios-eye" shape="circle"></Button></Tooltip>
                </i-col>
            </Row>
            <form-item label="Resumo" prop="resumo">
                <i-input placeholder="Resumo..." size="large" v-model="reclamacao.resumo" :disabled="reclamacao.analise_gestao === 1"></i-input>
            </form-item>
            <form-item label="Descrição Detalhada" prop="descricao">
                <vue-editor :editorToolbar="custom_toolbar" v-model="reclamacao.descricao" :disabled="reclamacao.analise_gestao === 1"></vue-editor>
            </form-item>
            <form-item label="Resposta" v-if="reclamacao.resposta_gestao">
                <Card dis-hover padding="5"><div v-html="reclamacao.resposta_gestao"></div></Card>
            </form-item>
        </i-form>
        <div class="floating-btn">
            <i-button @click="validar()" icon="md-checkmark" shape="circle" type="primary" v-show="reclamacao.analise_gestao === 0"></i-button>
        </div>
    </Card>
</template>

<script>
    const {editorToolbar} = require("../helpers/utils.js");
    export default {
        name: "canal-anonimo",
        components: {
            VueEditor: () =>
                import("vue2-editor").then(({VueEditor}) => VueEditor)
        },
        data() {
            return {
                reclamacao: {
                    id: 0,
                    hash: "",
                    resumo: "",
                    descricao: "",
                    analise_gestao: 0,
                    resposta_gestao: ""
                },
                rules_validate: {
                    resumo: [
                        {
                            required: true,
                            message: "Forneça um resumo simples",
                            trigger: "blur"
                        }
                    ],
                    descricao: [
                        {
                            required: true,
                            message: "Faça uma descrição detalhada",
                            trigger: "blur"
                        }
                    ],
                },
                custom_toolbar: editorToolbar
            }
        },
        methods: {

            /**
             * Antes de Salvar valida os dados dos inputs
             */
            validar() {
                this.$refs.reclamacao.validate(valid => {
                    if (!valid) {
                        this.$Message.error("Há campos não informados!");
                    } else {
                        this.salvar();
                    }
                });
            },
            /**
             * Atualiza um cadastro existente, ou cria um novo
             */
            async salvar() {
                this.$Spin.show();
                const reclamacao = this.reclamacao;

                try {
                    const id_reclamacao = this.reclamacao.id;
                    const URI = `canalanonimo`;
                    if (id_reclamacao === 0) {
                        const {data} = await this.$axios.post(URI, reclamacao);
                        const {id, hash} = data;
                        this.reclamacao.id = id;
                        this.reclamacao.hash = hash;
                        this.$Modal.info({
                            title: 'Chave única para visualização.',
                            content: hash
                        });
                    } else {
                        await this.$axios.put(`${URI}/${id_reclamacao}`, reclamacao);
                    }
                    this.$Message.success("Reclamação salva com sucesso!");
                    this.$Spin.hide();
                } catch (error) {
                    console.warn(error);
                    this.$Modal.error({
                        title: 'Erro!',
                        content: error
                    });
                    this.$Spin.hide();
                }
            },
            editarReclamacao () {
                let hash;
                this.$Modal.confirm({
                    title: 'Informe o código para edição!',
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: '',
                                autofocus: true,
                            },
                            on: {
                                input: (val) => {
                                    hash = val;
                                }
                            }
                        })
                    },
                    onOk: async () => {
                        try {
                            const URI = `canalanonimo/${hash}`;
                            const {data} = await this.$axios.get(URI);
                            if (data.analise_gestao) {
                                this.$Message.info({
                                    content: 'Esta reclamação já foi analisada pela gestão e não pode ser editada.',
                                    duration: 5,
                                    closable: true
                                });
                            }
                            if (data) {
                                this.reclamacao = data;
                            } else {
                                this.$Message.error({
                                    content: 'Reclamação não encontrada.',
                                    duration: 5,
                                    closable: true
                                });
                            }
                        } catch (error) {
                            console.warn(error);
                            this.$Modal.error({
                                title: 'Erro!',
                                content: error
                            });
                        }
                    },
                })
            }
        }
    }
</script>

<style scoped>

</style>